import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  queryFieldDetail: (data) => http.post(`${hr}/field/queryFieldDetail`, data), // 外勤明细查询
  queryField: (data) => http.post(`${hr}/field/queryField`, data), // 外勤汇总查询
  sync: (data) => http.post(`${hr}/field/sync`, data), // 同步按钮
  // 明细导出
  exportDetail: (data) =>
    http.post(`${hr}/field/exportDetail`, data, {
      responseType: "blob",
    }),
  // 汇总导出
  exportSum: (data) =>
    http.post(`${hr}/field/exportSum`, data, {
      responseType: "blob",
    }),
  updateById: (data) => http.post(`${hr}/field/updateById`, data), // 编辑
};
